// paymentMethod distinguishes what 'pending' actually means - a submission is created fully
// filled in (no draft state exists backend-side, see controllers/app/SalesController.js's
// exports.salesSubmission), so 'pending' with no paymentMethod yet IS already ready for staff to
// collect/register payment on, same as 'counter-pending'. Only once an online method (Card/
// GrabPay/PayNow/Link) has actually been charged and is awaiting the Omise webhook does 'pending'
// mean something else - already in flight, not idle and ready.
const isOnlineMethodPending = (status, paymentMethod) => status === 'pending' && paymentMethod && paymentMethod !== 'Counter'

export const resolvePaymentStatusVariant = (status, paymentMethod) => {
  if (isOnlineMethodPending(status, paymentMethod)) return 'light-warning'
  if (status === 'counter-pending' || status === 'pending') return 'light-success'
  if (status === 'successful' || status === 'completed') return 'light-success'
  return 'light-primary'
}

export const resolvePaymentStatusLabel = (status, paymentMethod) => {
  if (isOnlineMethodPending(status, paymentMethod)) return 'Processing'
  if (status === 'counter-pending' || status === 'pending') return 'Ready for Payment'
  if (status === 'successful') return 'Paid'
  if (status === 'completed') return 'Completed'
  return status || '–'
}

export const resolvePaymentTypeLabel = paymentType => {
  if (paymentType === 'bookingfee') return 'Booking fee'
  if (paymentType === 'downpayment') return 'Downpayment'
  if (paymentType === 'fullpayment') return 'Full payment'
  return paymentType || '–'
}
